export var TransitionDirection;
(function (TransitionDirection) {
    TransitionDirection["FORWARD"] = "forward";
    TransitionDirection["BACKWARD"] = "backward";
    TransitionDirection["BOTH"] = "both";
})(TransitionDirection || (TransitionDirection = {}));
export var LayerTransitionType;
(function (LayerTransitionType) {
    LayerTransitionType["VALUE"] = "value";
    LayerTransitionType["STEPPED"] = "stepped";
})(LayerTransitionType || (LayerTransitionType = {}));
